module.exports = __webpack_public_path__ + "staticcomp/img/top.12be216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/top.jpg
// module id = X6vc
// module chunks = 39